module.exports = __webpack_public_path__ + "img/25.b51e8fbc.png";